var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BFormCheckbox } from "bootstrap-vue";
import { ref, watch } from "vue";
import FormGeneric from "@/components/Form/FormGeneric.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetPermissionsForm',
    props: {
        loading: { type: Boolean },
        simplePermissions: { type: Boolean },
        title: null,
        checked: { type: Boolean },
        formConfig: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faUsers);
        const selectedAdvancedForm = ref(false);
        const checkedInForm = ref(props.checked);
        function change(value) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("change", value);
            });
        }
        watch(props, () => {
            checkedInForm.value = props.checked;
        });
        return { __sfc: true, props, selectedAdvancedForm, checkedInForm, emit, change, faUsers, FontAwesomeIcon, BFormCheckbox, FormGeneric, LoadingSpan };
    }
});
